//token storage for the two areas of this app
export const AFF_TOKEN_KEY = 'wn_aff_token';
export const ADMIN_TOKEN_KEY = 'wn_aff_admin_token';
export const NOTICE_KEY = 'wn_aff_notice';

const lsGet = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
const lsSet = (k, v) => { try { localStorage.setItem(k, v); } catch (e) { } };
const lsDel = (k) => { try { localStorage.removeItem(k); } catch (e) { } };

//read the exp claim of a JWT (no signature check, the server always verifies)
const tokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    return payload.exp ? payload.exp * 1000 < Date.now() : false;
  } catch (e) {
    return true;
  }
};

const validToken = (key) => {
  const t = lsGet(key);
  if (!t) return null;
  if (tokenExpired(t)) {
    lsDel(key);
    return null;
  }
  return t;
};

export const getAffToken = () => validToken(AFF_TOKEN_KEY);
export const setAffToken = (t) => lsSet(AFF_TOKEN_KEY, t);
export const clearAffToken = () => lsDel(AFF_TOKEN_KEY);

export const getAdminToken = () => validToken(ADMIN_TOKEN_KEY);
export const setAdminToken = (t) => lsSet(ADMIN_TOKEN_KEY, t);
export const clearAdminToken = () => lsDel(ADMIN_TOKEN_KEY);

//one-time message shown on the login page (e.g. "session expired")
export const setNotice = (msg) => { try { sessionStorage.setItem(NOTICE_KEY, msg); } catch (e) { } };
export const takeNotice = () => {
  try {
    const m = sessionStorage.getItem(NOTICE_KEY);
    sessionStorage.removeItem(NOTICE_KEY);
    return m || '';
  } catch (e) {
    return '';
  }
};
